import {Dispatch, FC, SetStateAction} from "react";
import {
  CalendarWeekFlowTrigger,
  ContractStartFlowTrigger,
  FlowTrigger
} from "../../../../../lib/src/api/repositories/flows-repository";
import {Input} from "../../../../../lib/src/components/form/Input";

export const TriggerEditor: FC<{trigger: FlowTrigger, setTrigger: Dispatch<SetStateAction<FlowTrigger>>}> = ({trigger, setTrigger}) => {
  return <div className={'flex flex-col items-stretch px-3'}>
    <div className={'rounded-lg bg-brand-primary-container text-brand-on-primary-container px-4 py-3'}>
      {trigger.type === 'contract_start' && <ContractStartTriggerEditor trigger={trigger} setTrigger={setTrigger} />}
      {trigger.type === 'calendar_week' && <CalendarWeekTriggerEditor trigger={trigger} setTrigger={setTrigger} />}
    </div>
  </div>
}
const ContractStartTriggerEditor: FC<{trigger: ContractStartFlowTrigger, setTrigger: Dispatch<SetStateAction<FlowTrigger>>}> = ({trigger, setTrigger}) => {
  return <div className={''}>
    <h2 className={'font-medium'}>Contractdatum</h2>
    <p className={'text-sm text-opacity-70 mt-1 mb-2'}>
      De flow wordt gestart op een aantal dagen na de ingangsdatum van het contract van de medewerker.<br/>
      Het aantal dagen mag ook negatief zijn, hierdoor kan de flow ook gestart worden voor de ingangsdatum van het contract.
    </p>
    <Input type={'number'} label={'Aantal dagen na contractdatum'} value={trigger.params.days_offset ?? 0} onChange={(v) => {
      setTrigger({...trigger, params: {...trigger.params, days_offset: v }})
    }} />
  </div>
}

const CalendarWeekTriggerEditor: FC<{trigger: CalendarWeekFlowTrigger, setTrigger: Dispatch<SetStateAction<FlowTrigger>>}> = ({trigger, setTrigger}) => {
  return <div className={''}>
    <h2 className={'font-medium'}>Kalenderweek</h2>
    <p className={'text-sm text-opacity-70 mt-1 mb-2'}>
      De flow wordt gestart op de eerste werkdag van de desbetreffende week.
    </p>
    <Input type={'number'} label={'Weeknummer'} value={trigger.params.week_number ?? 0} onChange={(v) => {
      setTrigger({...trigger, params: {...trigger.params, week_number: v }})
    }} />
  </div>
}